export const CREATE_EVENT = 'CREATE_EVENT'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const SET_WEEKENDS_ENABLED = 'SET_WEEKENDS_ENABLED'
export const SET_BOOKINGS = 'SET_BOOKINGS'
